import React from 'react';
import { LayoutDashboard, MapPin, Activity, ShieldAlert } from 'lucide-react';

const TABS = [
  { key: 'overview', label: 'Overview', icon: LayoutDashboard },
  { key: 'location', label: 'Location', icon: MapPin },
  { key: 'activity', label: 'Activity', icon: Activity },
  { key: 'risk', label: 'Risk', icon: ShieldAlert },
];

const SECTION_LINKS = {
  location: [
    { id: 'known-locations', label: 'Known Locations' },
    { id: 'schedule', label: 'Schedule' },
    { id: 'boundaries', label: 'Boundaries' },
    { id: 'location-check', label: 'Location Check' },
  ],
  activity: [
    { id: 'current-movement', label: 'Current Movement' },
    { id: 'travel-history', label: 'Travel History' },
    { id: 'heatmaps', label: 'Heatmaps' },
    { id: 'behavior-profile', label: 'Behavior Profile' },
  ],
  risk: [
    { id: 'risk-assessment', label: 'Risk Assessment' },
    { id: 'unusual-activity', label: 'Unusual Activity' },
    { id: 'dangerous-areas', label: 'Dangerous Areas' },
    { id: 'connections', label: 'Connections' },
  ],
};

const PolTabNavigation = ({ activeTab, setActiveTab }) => {
  const sectionLinks = SECTION_LINKS[activeTab] || null;

  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  return (
    <div className="mb-6">
      {/* Main Tab Bar */}
      <div className="flex gap-1 border-b border-gray-200">
        {TABS.map((tab) => {
          const Icon = tab.icon;
          const isActive = activeTab === tab.key;
          return (
            <button
              key={tab.key}
              onClick={() => setActiveTab(tab.key)}
              className={`flex items-center gap-2 px-6 py-3 font-semibold text-sm transition-colors border-b-2 ${
                isActive
                  ? 'text-[#184A89] border-[#184A89] bg-white'
                  : 'text-gray-500 border-transparent hover:text-gray-700 hover:bg-gray-50'
              }`}
            >
              <Icon size={18} />
              {tab.label}
            </button>
          );
        })}
      </div>

      {/* Section Jump Bar */}
      {sectionLinks && (
        <div className="flex flex-wrap items-center gap-2 mt-3 px-1">
          <span className="text-xs text-gray-400 font-medium uppercase tracking-wide">Jump to:</span>
          {sectionLinks.map((link) => (
            <button
              key={link.id}
              onClick={() => scrollToSection(link.id)}
              className="px-3 py-1 text-xs font-medium text-gray-600 bg-gray-100 rounded-full hover:bg-gray-200 hover:text-gray-800 transition-colors"
            >
              {link.label}
            </button>
          ))}
        </div>
      )}
    </div>
  );
};

export default PolTabNavigation;
